/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
  DropDownComponent,
  TableComponent,
  CalendarComponent,
  RefreshTimestamp
} from "../../CommonComponents";
import "../styles.scss";
import Heading from "../../../../components/Heading";
import { getHubList, getHubCPList } from "../../../../services/api/hub";
import { ReportsService } from "../../../../services/api/reports";
import { downloadFastTrackReport } from "../../../../utils/downloadUtils";
import {
  ZONE_OPTIONS,
  REPORT_PAGINATION_DEFAULTS,
  REPORT_FILTER_LABELS,
  REPORT_PLACEHOLDERS,
  REPORT_DOWNLOAD_TEXT,
  REPORT_ERROR_MESSAGES,
  SERVICE_TYPE_OPTIONS,
  BOOKING_TYPE_OPTIONS
} from "../../../../constants/reportConstants";

const FastTrackReport = () => {
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [cpLoading, setCpLoading] = useState(false);
  const [dateRange, setDateRange] = useState([
    moment().subtract(1, "days"),
    moment()
  ]);
  const [hubList, setHubList] = useState([]);
  const [cpList, setCpList] = useState([]);
  const [selectedParentHubs, setSelectedParentHubs] = useState([]);
  const [selectedDestinationHubs, setSelectedDestinationHubs] = useState([]);
  const [selectedBookingCPs, setSelectedBookingCPs] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  const [selectedBookingTypes, setSelectedBookingTypes] = useState([]);
  const [pagination, setPagination] = useState({
    ...REPORT_PAGINATION_DEFAULTS
  });
  const [reportData, setReportData] = useState([]);
  const [hubUser, setHubUser] = useState();
  const [lastsynced, setLastsynced] = useState(null);
  const [nextScheduledRefresh, setNextScheduledRefresh] = useState(null);


  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const hubs = await getHubList();
        setHubList(hubs);
      } catch {
        message.error(REPORT_ERROR_MESSAGES.FETCH_HUB_LIST_FAILED);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userinfo"));
    let userid = JSON.parse(localStorage.getItem("userId"));
    setHubUser(user?.roles?.[0]);
    const activeHub = JSON.parse(localStorage.getItem("active_hub"));
    const activeHubId = activeHub?.hubId;

    if (hubList.length > 0) {
      if (activeHubId) {
        const defaultHub = hubList.find((hub) => String(hub.value) === String(activeHubId));
        if (defaultHub) {
          setSelectedParentHubs([defaultHub.value]);
        }
      } else if (user?.roles?.[0] === "ROLE_HUBADMIN") {
        const defaultHub = hubList.find(hub => String(hub.value) === String(userid?.userInfo?.premiseId));
        if (defaultHub) {
          setSelectedParentHubs([defaultHub.value]);
        }
      }
    }
  }, [hubList]);

  useEffect(() => {
    if (!selectedParentHubs || selectedParentHubs.length === 0) {
      setCpList([]); // clear CP list if no hub selected
      setSelectedBookingCPs([]); // Clear selected CPs when hub selection changes
      return;
    }

    (async () => {
      try {
        setCpLoading(true);
        const cpLists = await Promise.all(selectedParentHubs.map(hubId => getHubCPList(hubId)));
        const allCps = [...new Set(cpLists.flat())];
        setCpList(allCps);
      } catch (error) {
        console.error("Failed to fetch CP list", error);
        message.error(REPORT_ERROR_MESSAGES.FETCH_CP_LIST_FAILED);
        setCpList([]);
      } finally {
        setCpLoading(false);
      }
    })();
  }, [selectedParentHubs]);

  useEffect(() => {
    if (!hubUser) {
      return;
    }
    if (hubUser === "ROLE_HUBADMIN" && selectedParentHubs.length === 0) {
      return;
    }
    fetchReport();
    // eslint-disable-next-line
  }, [hubUser, selectedParentHubs, selectedDestinationHubs, selectedBookingCPs, selectedZones, selectedServiceTypes, selectedBookingTypes, dateRange, pagination.current, pagination.pageSize]);

  const fetchReport = async () => {
    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      message.warning(REPORT_ERROR_MESSAGES.SELECT_DATE_RANGE);
      return;
    }

    setLoading(true);
    try {
      const selectedParentHubData = hubList.filter(hub => selectedParentHubs?.includes(hub.value));
      const selectedDestHubData = hubList.filter(hub => selectedDestinationHubs?.includes(hub.value));

      const params = {
        size: pagination.pageSize,
        page: pagination.current - 1,
        fromDate: dateRange[0].format("YYYY-MM-DD"),
        toDate: dateRange[1].format("YYYY-MM-DD"),
        ...(selectedParentHubData?.length > 0 && { parentHubIds: selectedParentHubData.map(hub => hub.value) }),
        ...(selectedDestHubData?.length > 0 && { destinationHubIds: selectedDestHubData.map(hub => hub.value) }),
        ...(selectedBookingCPs?.length > 0 && { bookingCpIds: selectedBookingCPs }),
        ...(selectedZones?.length > 0 && { zones: selectedZones }),
        ...(selectedServiceTypes?.length > 0 && { serviceTypes: selectedServiceTypes }),
        ...(selectedBookingTypes?.length > 0 && { bookingTypes: selectedBookingTypes })
      };

      console.log("Fetching fast track report with params:", params);
      const response = await ReportsService.getFastTrackReport(params);
      console.log("Fast track report response:", response);

      if (response?.lastRefreshedAt) {
        setLastsynced(response.lastRefreshedAt);
      }
      if (response?.nextScheduledRefresh) {
        setNextScheduledRefresh(response.nextScheduledRefresh);
      }
      if (response?.data) {
        setReportData(response.data);
        setPagination(prev => ({
          ...prev,
          total: response.total || 0,
          current: (response.page || 0) + 1,
          pageSize: response.size || 10
        }));
      } else {
        setReportData([]);
        setPagination(prev => ({
          ...prev,
          total: 0
        }));
        message.error("No data available");
      }
    } catch (error) {
      console.error("Error fetching fast track report:", error);
      message.error(error?.message || REPORT_ERROR_MESSAGES.FETCH_REPORT_FAILED);
      setReportData([]);
      setPagination(prev => ({
        ...prev,
        total: 0
      }));
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination) => {
    setPagination(prev => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize
    }));
  };

  const handleDownload = async () => {
    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      message.warning(REPORT_ERROR_MESSAGES.SELECT_DATE_RANGE);
      return;
    }
    setDownloadLoading(true);
    try {
      const selectedParentHubData = hubList.filter(hub => selectedParentHubs?.includes(hub.value));
      const selectedDestHubData = hubList.filter(hub => selectedDestinationHubs?.includes(hub.value));

      const downloadParams = {
        fromDate: dateRange[0].format("YYYY-MM-DD"),
        toDate: dateRange[1].format("YYYY-MM-DD"),
        ...(selectedParentHubData?.length > 0 && { parentHubIds: selectedParentHubData.map(hub => hub.value) }),
        ...(selectedDestHubData?.length > 0 && { destinationHubIds: selectedDestHubData.map(hub => hub.value) }),
        ...(selectedBookingCPs?.length > 0 && { bookingCpIds: selectedBookingCPs }),
        ...(selectedZones?.length > 0 && { zones: selectedZones }),
        ...(selectedServiceTypes?.length > 0 && { serviceTypes: selectedServiceTypes }),
        ...(selectedBookingTypes?.length > 0 && { bookingTypes: selectedBookingTypes })
      };

      await downloadFastTrackReport(downloadParams);
      message.success(REPORT_DOWNLOAD_TEXT.SUCCESS);
    } catch (error) {
      console.error("Error downloading fast track report:", error);
      message.error(REPORT_DOWNLOAD_TEXT.ERROR);
    } finally {
      setDownloadLoading(false);
    }
  };

  const columns = [
    {
      title: "No.",
      dataIndex: "index",
      key: "index",
      width: 60,
      fixed: "left",
      render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Document No",
      dataIndex: "documentNo",
      key: "documentNo",
      sorter: true,
      width: 140,
      fixed: "left",
      render: (text, record) => (
        <span
          style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => {
            const url = `/shipment-tracker?awb=${text}`;
            window.open(url, "_blank");
          }}
        >
          {text}
        </span>
      )
    },
    { title: "Booking Date", dataIndex: "bookingDate", key: "bookingDate", sorter: true, width: 120 },
    { title: "Booking CP", dataIndex: "bookingCp", key: "bookingCp", sorter: true, width: 180 },
    { title: "Source Hub", dataIndex: "parentHubName", key: "parentHubName", sorter: true, width: 180 },
    { title: "From State", dataIndex: "fromState", key: "fromState", sorter: true, width: 130 },
    { title: "To Pincode", dataIndex: "toPincode", key: "toPincode", sorter: true, width: 110 },
    { title: "To City", dataIndex: "toCity", key: "toCity", sorter: true, width: 130 },
    { title: "To State", dataIndex: "toState", key: "toState", sorter: true, width: 130 },
    { title: "Destination Hub", dataIndex: "destinationHubName", key: "destinationHubName", sorter: true, width: 200 },
    { title: "To Center", dataIndex: "toCenter", key: "toCenter", sorter: true, width: 150 },
    { title: "Receiver Name", dataIndex: "receiverName", key: "receiverName", sorter: true, width: 150 },
    { title: "Area Name", dataIndex: "areaName", key: "areaName", sorter: true, width: 130 },
    { title: "Booking Type", dataIndex: "bookingType", key: "bookingType", sorter: true, width: 120 },
    { title: "Service Type", dataIndex: "serviceType", key: "serviceType", sorter: true, width: 120 },
    { title: "Document Type", dataIndex: "documentType", key: "documentType", sorter: true, width: 130 },
    { title: "Travel By", dataIndex: "travelBy", key: "travelBy", sorter: true, width: 100 },
    { title: "Weight (kg)", dataIndex: "bookingWeight", key: "bookingWeight", sorter: true, width: 110 },
    { title: "Charges", dataIndex: "charges", key: "charges", sorter: true, width: 100 },
    { title: "Zone", dataIndex: "zone", key: "zone", sorter: true, width: 100 },
    { title: "Status", dataIndex: "status", key: "status", sorter: true, width: 120 },
    { title: "Delivery Date", dataIndex: "deliveryDate", key: "deliveryDate", sorter: true, width: 120 },
    { title: "POD", dataIndex: "pod", key: "pod", sorter: true, width: 100 },

  ];

  return (
    <div className="report-container">
      <div style={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "8px" }}>
        <Heading title="Fast Track / Value Plus Report">
          <div style={{ paddingTop: "5px" }}>
            <RefreshTimestamp
              lastRefreshedAt={lastsynced}
              nextScheduledRefresh={nextScheduledRefresh}
            />
          </div>
        </Heading>
      </div>
      <Card className="report-card">
        <Row gutter={[16, 16]} className="filters-section">
          <Col xs={24} sm={12} md={8} lg={6}>
            <div className="filter-label">Date Range</div>
            <CalendarComponent
              className="custom-calendar"
              type="range"
              value={dateRange}
              onChange={(value) => {
                setDateRange(value);
                setPagination(prev => ({ ...prev, current: 1 }));
              }}
              format="YYYY-MM-DD"
              allowClear
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <div className="filter-label">Parent Hub</div>
            <DropDownComponent
              className="small-dropdown"
              placeholder="Parent Hub"
              options={hubList}
              onChange={(value) => {
                setSelectedParentHubs(value);
                setPagination(prev => ({ ...prev, current: 1 }));
              }}
              value={selectedParentHubs}
              mode={hubUser !== "ROLE_HUBADMIN" ? "multiple" : "default"}
              allowClear
              maxTagCount="responsive"
              showSearch={true}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label || "").toLowerCase().includes(input.toLowerCase())
              }
              disabled={hubUser === "ROLE_HUBADMIN"}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <div className="filter-label">Destination Hub</div>
            <DropDownComponent
              className="small-dropdown"
              placeholder="Destination Hub"
              options={hubList}
              onChange={(value) => {
                setSelectedDestinationHubs(value);
                setPagination(prev => ({ ...prev, current: 1 }));
              }}
              value={selectedDestinationHubs}
              mode="multiple"
              allowClear
              maxTagCount="responsive"
              showSearch={true}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label || "").toLowerCase().includes(input.toLowerCase())
              }
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <div className="filter-label">Booking CP</div>
            <DropDownComponent
              className="small-dropdown"
              placeholder={cpLoading ? REPORT_PLACEHOLDERS.LOADING_CPS : cpList.length === 0 ? REPORT_PLACEHOLDERS.SELECT_HUB_FIRST : "Select Booking CP"}
              options={cpList}
              onChange={(value) => {
                setSelectedBookingCPs(value);
                setPagination(prev => ({ ...prev, current: 1 }));
              }}
              value={selectedBookingCPs}
              allowClear
              mode="multiple"
              maxTagCount="responsive"
              disabled={cpLoading || cpList.length === 0}
              loading={cpLoading}
              showSearch={true}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label || "").toLowerCase().includes(input.toLowerCase())
              }
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <div className="filter-label">{REPORT_FILTER_LABELS.ZONES}</div>
            <DropDownComponent
              placeholder={REPORT_PLACEHOLDERS.SELECT_ZONES}
              options={ZONE_OPTIONS}
              onChange={(value) => {
                setSelectedZones(value);
                setPagination(prev => ({ ...prev, current: 1 }));
              }}
              value={selectedZones}
              allowClear
              mode="multiple"
              maxTagCount="responsive"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <div className="filter-label">Service Types</div>
            <DropDownComponent
              placeholder="Service Types"
              options={SERVICE_TYPE_OPTIONS}
              onChange={(value) => {
                setSelectedServiceTypes(value);
                setPagination(prev => ({ ...prev, current: 1 }));
              }}
              value={selectedServiceTypes}
              allowClear
              mode="multiple"
              maxTagCount="responsive"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <div className="filter-label">Booking Types</div>
            <DropDownComponent
              placeholder="Select Booking Types"
              options={BOOKING_TYPE_OPTIONS}
              onChange={(value) => {
                setSelectedBookingTypes(value);
                setPagination(prev => ({ ...prev, current: 1 }));
              }}
              value={selectedBookingTypes}
              allowClear
              mode="multiple"
              maxTagCount="responsive"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            <Button
              type="primary"
              onClick={handleDownload}
              loading={downloadLoading}
              icon={<DownloadOutlined />}
              disabled={!dateRange || !dateRange[0] || !dateRange[1]}
            >
              {REPORT_DOWNLOAD_TEXT.BUTTON}
            </Button>
          </Col>
        </Row>

        <div className="table-section">
          <TableComponent
            columns={columns}
            dataSource={reportData}
            loading={loading}
            pagination={pagination}
            onChange={handleTableChange}
            rowKey="documentNo"
            scroll={{ x: 2000 }}
          />
        </div>
      </Card>
    </div>
  );
};

export default FastTrackReport;
